var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReloadIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1880_6481",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1880_6481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9998 18.1083C31.9579 25.8089 25.6744 32.0319 17.9754 31.9999C10.2025 31.9654 3.94366 25.6587 4.00038 17.9187C4.0571 10.2428 10.38 3.97545 18.0395 4.00007C25.7755 4.0247 32.0417 10.3585 31.9998 18.1083ZM20.9643 18.1009C22.3526 19.5613 23.5265 20.7975 24.794 22.1298C26.0616 20.7901 27.2477 19.5366 28.6065 18.0985C27.6546 18.0517 27.0159 18.0221 26.3994 17.9901C24.8187 11.6071 21.1369 8.58298 16.1974 9.54832C11.396 10.4866 8.3924 14.6237 9.09029 19.3322C9.70926 23.494 13.6426 26.8678 17.5241 26.4886V23.7649C13.2949 22.674 11.4059 20.2877 12.0446 16.914C12.5797 14.0869 15.3121 12.0626 18.185 12.3631C21.0604 12.6635 23.2749 15.1064 23.2084 17.9803C22.5771 18.0148 21.9359 18.0468 20.9618 18.0985L20.9643 18.1009Z",
    fill: "#BFBFBF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadIcon);
export default __webpack_public_path__ + "static/media/Reload-icon.896f7b2e51880df1604b378b1e79de1b.svg";
export { ForwardRef as ReactComponent };